/**
 * Find all scrollable parents of the element.
 */
import getScrollParent from "./getScrollParent"
import { getParentNode, getWindow, isBodyElement } from "../utils"

type Parents = (Element | Window)[]

const getScrollParents = (element: Node, parents: Parents = []): Parents => {
  const scrollParent = getScrollParent(element)
  const isBody = isBodyElement(scrollParent)

  return isBody
    ? parents.concat(getWindow(scrollParent))
    : parents.concat(
        scrollParent,
        getScrollParents(getParentNode(scrollParent))
      )
}

export default getScrollParents
